import { render, staticRenderFns } from "./ReportsDeliveryPeriodView.vue?vue&type=template&id=6495f9de"
import script from "./ReportsDeliveryPeriodView.vue?vue&type=script&lang=ts"
export * from "./ReportsDeliveryPeriodView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports